import { Table } from "./Table";
export { Table };
